module.exports = __webpack_public_path__ + "img/cover_cathouse.97056590.png";